module.exports = __webpack_public_path__ + "media/images/payments/amazon-dark-3aa03461587957e0acde7fc1acb045e2.svg";